import { useParams } from "react-router-dom";
import PageContentWrapper from "../../components/PageContentWrapper";
import { useEffect, useRef, useState } from "react";
import CircularProgress from "../../components/CircularProgress";
import { getTrainingMaterialPdf } from "../../appRedux/actions/TrainingMaterial";
import { Document, Page, pdfjs } from 'react-pdf'
import "../../assets/react-pdf-custom.css";
import { Button, Col, Layout, Pagination, Row, Space } from 'antd';
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry";
import { contentStyle, footerStyle, headerStyle, layoutStyle } from "../../util/LayoutStyles";
import { FullscreenExitOutlined, FullscreenOutlined, LeftCircleOutlined, RightCircleOutlined, ZoomInOutlined, ZoomOutOutlined } from "@ant-design/icons";
import { symmetric_decrypt } from "../../libs/cryptography";

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
const { Header, Footer, Sider, Content } = Layout;

export default function TrainingMaterialPdf() {
  const { trainingMaterialId, trainingRegistrationId } = useParams()
  const [pdf, setPdf] = useState(null)
  const [numPages, setNumPages] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [full, setFull] = useState(false);
  const pdfRef = useRef()
  let pdfWidth = 100
  let intervalRef

  useEffect(() => {
    fetchData()
  }, [])

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    canvasContextMenu()
  }

  function fetchData() {
    getTrainingMaterialPdf(trainingMaterialId, trainingRegistrationId).then(data => {
      setPdf(data)
    })
  }

  function nextPage() {
    if (pageNumber >= numPages)
      return
    setPageNumber(pageNumber + 1)
    canvasContextMenu()
  }

  function previousPage() {
    if (pageNumber <= 1)
      return
    setPageNumber(pageNumber - 1)
    canvasContextMenu()
  }

  function onChangePage(pageNumber) {
    if (pageNumber >= 1 && pageNumber <= numPages) {
      setPageNumber(pageNumber)
      canvasContextMenu()
    }
  }

  function fullScreen() {
    const pdfComp = pdfRef.current
    if (!pdfComp)
      return
    try {
      if (full) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) { /* Safari */
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { /* IE11 */
          document.msExitFullscreen();
        }
      } else {
        if (pdfComp.requestFullscreen) {
          pdfComp.requestFullscreen();
        } else if (pdfComp.webkitRequestFullscreen) { /* Safari */
          pdfComp.webkitRequestFullscreen();
        } else if (pdfComp.msRequestFullscreen) { /* IE11 */
          pdfComp.msRequestFullscreen();
        }
      }
      setFull(!full)
    } catch (error) {

    }
  }

  function canvasContextMenu() {
    setTimeout(() => {
      const canvases = document.getElementsByTagName('canvas')
      for (const canvas of canvases) {
        canvas.oncontextmenu = function () { return false }
      }
    }, 100)
  }

  function startCounter(plus) {
    if (intervalRef) return;
    intervalRef = setInterval(() => {
      zoom(plus)
    }, 20);
  };

  function stopCounter() {
    if (intervalRef) {
      clearInterval(intervalRef);
      intervalRef = null;
    }
  };

  function zoom(plus) {
    const canvas = document.getElementsByClassName('react-pdf__Page__canvas')[0]
    if (plus === true)
      pdfWidth++
    else if (plus === false && pdfWidth > 10)
      pdfWidth--
    canvas.setAttribute("style", "width: " + pdfWidth + "% !important")
  }

  return (
    <PageContentWrapper
      backLink={"/training-registration/" + trainingRegistrationId}
      title={"Materi Training"}>
      {pdf ? (
        <div ref={pdfRef} style={{ height: '100%', overflow: 'auto' }}>
          <Layout style={layoutStyle}>
            <Header style={headerStyle}>
              <Row style={{ width: '100%' }}>
                <Col span={2}>
                  <div style={{ cursor: 'pointer', margin: 0 }} onClick={previousPage}><LeftCircleOutlined /></div>
                </Col>
                <Col span={4}>{pdf.name}</Col>
                <Col span={0} xs={14}>
                  <Row justify="end" gutter={2}>
                    <Col span={0} sm={16} md={8} lg={6}>
                      {full ? (
                        <Button ghost icon={<FullscreenExitOutlined />} style={{ margin: 'auto' }} onClick={fullScreen}>
                          Keluar dari Layar Penuh
                        </Button>
                      ) : (
                        <Button ghost icon={<FullscreenOutlined />} style={{ margin: 'auto' }} onClick={fullScreen}>
                          Layar Penuh
                        </Button>
                      )}
                    </Col>
                    <Col span={6} sm={0}>
                      {full ? (
                        <Button ghost icon={<FullscreenExitOutlined />} style={{ margin: 'auto' }} onClick={fullScreen}>
                        </Button>
                      ) : (
                        <Button ghost icon={<FullscreenOutlined />} style={{ margin: 'auto' }} onClick={fullScreen}>
                        </Button>
                      )}
                    </Col>
                    <Col span={0} xs={0} sm={4} md={2}>
                      <Button ghost icon={<ZoomInOutlined />} style={{ margin: 'auto' }}
                        onMouseDown={() => { startCounter(true) }}
                        onMouseUp={stopCounter}
                        onMouseLeave={stopCounter}
                      />
                    </Col>
                    <Col span={0} xs={0} sm={4} md={2}>
                      <Button ghost icon={<ZoomOutOutlined />} style={{ margin: 'auto' }}
                        onMouseDown={() => { startCounter(false) }}
                        onMouseUp={stopCounter}
                        onMouseLeave={stopCounter}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col span={2}>
                  <div style={{ cursor: 'pointer' }} onClick={nextPage}><RightCircleOutlined /></div>
                </Col>
              </Row>
            </Header>
            <Content style={contentStyle}>
              <Document
                file={"data:application/pdf;base64," + symmetric_decrypt(pdf.data)}
                onLoadSuccess={onDocumentLoadSuccess}
                loading={<CircularProgress />}
              >
                <Page pageNumber={pageNumber} />
              </Document>
            </Content>
            <Footer style={footerStyle}>
              <Pagination
                responsive={true}
                showLessItems={true}
                defaultCurrent={pageNumber}
                current={pageNumber}
                total={numPages}
                pageSize={1}
                onChange={onChangePage}
                style={{ margin: 'auto' }}
                showQuickJumper
              />
            </Footer>
          </Layout>
        </div>
      ) : (
        <CircularProgress />
      )}
    </PageContentWrapper>
  )
}